// function to generate group ID based on the group name + random number
export const generateGroupID = (groupName) => {
    // remove spaces from group name
    groupName = groupName.replace(/\s/g, '');
    // add a random number between 1 and 10000 to the group name
    const groupID = groupName + Math.floor(Math.random() * 10000);

    // TODO: verify that the group ID is unique in DB

    return groupID;
}

// function to get group ID based on the default MQTT_TOPIC_PREFIX and topic path
export const getGroupIDFromTopic = (topic) => {
    // Based on topic structure for color topics: BlaineProjects/RemoteHearts/groups/[GROUP ID]/color or LumasHearts/groups/[GROUP ID]/color
    const topicValues = topic.split('/');
    let groupID = '';
    for (let i = 0; i < topicValues.length; i++) {
        if (topicValues[i] === 'groups') {
            groupID = topicValues[i + 1];
        }
    }
    return groupID;
}

// generate a unique MAC address for testing purposes (string in the format "XX:XX:XX:XX:XX:XX")
// needs current list of hearts to check for uniqueness
export const generateUniqueHeartId = (heartsList) => {
  let bytes = Array.from({ length: 6 }, () => Math.floor(Math.random() * 256)); // Generate 6 random bytes
  let randomMacAddress = bytes.map(byte => byte.toString(16).padStart(2, '0')).join(':'); // Format bytes as hexadecimal with leading zeros if necessary
  
  // regenerate MAC if already in use
  const heartIds = heartsList.map((heart) => heart.id);
  while (heartIds.includes(randomMacAddress.toUpperCase())) {
      bytes = Array.from({ length: 6 }, () => Math.floor(Math.random() * 256));
      randomMacAddress = bytes.map(byte => byte.toString(16).padStart(2, '0')).join(':');
  }
  return randomMacAddress.toUpperCase(); // Convert to uppercase for standard formatting
}

//takes in a number 0-1023 (the potentiometer range) and returns {red, green, or blue} object of that "index" of the rainbow
export const numberToRGB = (colorNumber) => {
    let r;
    let g;
    let b;
    //colorNumber is the index of the rainbow, 0-1023
    if(colorNumber === 0){
      r=255;
      g=0;
      b=0;
    }
    else if(colorNumber < 170){
      r=255;
      b=0;
      g=(colorNumber/170.0)*255;
    }else if(colorNumber<170*2){
      colorNumber=colorNumber-170;
      b=0;
      g=255;
      r=((170-colorNumber)/170.0)*255;
    }else if(colorNumber<170*3){
      colorNumber=colorNumber-170*2;
      r=0;
      g=255;
      b=(colorNumber/170.0)*255;
    }else if(colorNumber<170*4){
      colorNumber=colorNumber-170*3;
      r=0;
      b=255;
      g=((170-colorNumber)/170.0)*255;
    }else if(colorNumber<170*5){
      colorNumber=colorNumber-170*4;
      g=0;
      b=255;
      r=(colorNumber/170.0)*255;
    }else if(colorNumber<1025){
      colorNumber=colorNumber-170*5;
      g=0;
      r=255;
      b=((173-colorNumber)/173.0)*255; //173 cause this loop absorbs the remainder of 1024/6
    }else{ //should never be called, but if someone calls for a number outside of the range, we should return black instead of some strange number
      r=0;
      g=0;
      b=0;
    }

    // ensure that the values are integers
    r = Math.round(r);
    g = Math.round(g);
    b = Math.round(b);
    
    return {r, g, b};

}

// {red, green, or blue} object and returns a number 0-1023 (the potentiometer range) for that color
export const rgbToColorNumber = (r, g, b) => {
    if (r === 255 && g === 0 && b === 0) {
      return 0;
    } else if (r === 255 && g > 0 && g <= 255 && b === 0) {
        return Math.round((g / 255) * 170);
    } else if (r > 0 && r <= 255 && g === 255 && b === 0) {
        return 170 + Math.round(((255 - r) / 255) * 170);
    } else if (r === 0 && g === 255 && b > 0 && b <= 255) {
        return 340 + Math.round((b / 255) * 170);
    } else if (r === 0 && g > 0 && g <= 255 && b === 255) {
        return 510 + Math.round(((255 - g) / 255) * 170);
    } else if (r > 0 && r <= 255 && g === 0 && b === 255) {
        return 680 + Math.round((r / 255) * 170);
    } else if (r === 255 && g === 0 && b > 0 && b <= 255) {
        return 850 + Math.round(((255 - b) / 255) * 173);
    }else{ //should never be called, but if someone calls for a number outside of the range, we should return black instead of some strange number
      return 0;
    }
}

// Convert RGB values to IColor object (for react-color-palette compatibility)
export const rgbToIColor = (r, g, b) => {
    let hex, rgb, hsv;  
    const a = 255;

    rgb = { r, g, b, a };

    // convert RGB to HEX
    const rr = r.toString(16).padStart(2, "0");
    const gg = g.toString(16).padStart(2, "0");
    const bb = b.toString(16).padStart(2, "0");
    const aa = a.toString(16).padStart(2, "0");
  
    hex = ["#", rr, gg, bb].join("");

    // Convert RGB to HSV
    const max = Math.max(r, g, b);
    const d = max - Math.min(r, g, b);
    const h = d ? (max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? 2 + (b - r) / d : 4 + (r - g) / d) * 60 : 0;
    const s = max ? (d / max) * 100 : 0;
    const v = max * 100;

    hsv = { h, s, v, a };


    return { hex, rgb, hsv };
}

// Convert colorNumber to IColor object (for react-color-palette compatibility)
export const numberToIColor = (colorNumber) => {
    const {r, g, b} = numberToRGB(colorNumber);
    return rgbToIColor(r, g, b);
}